import React from 'react';

import burgerLogo from '../../assets/images/ABC-zainab16.png';
//import burgerLogo from '../../assets/images/ABC2.png';
import classes from './Logo.css';
import { useHistory } from 'react-router-dom';

function logo(props) {

const history = useHistory();

const routeChange=(pathExt)=> {
    let path = `/`;
    history.push(path); 
}

return (
    <div className={classes.Logo} style={{height: props.height, padding:'0px 0px 0px 0px'}}>
        <a href='' onClick={routeChange.bind(this, 'VlogMain')}><img src={burgerLogo} alt="AliBookClub"  style={{border:0}}/></a>
    </div>
);
}

export default logo;


// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js